import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { X, Cookie } from 'lucide-react';

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Show banner after 1 second delay for better UX
      setTimeout(() => setShow(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setShow(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setShow(false);
  };

  if (!show) return null;

  return (
    <>
      {/* Backdrop for desktop - very subtle and non-blocking */}
      <div 
        className="hidden md:block fixed inset-0 bg-black bg-opacity-5 z-40 transition-opacity pointer-events-none"
      />
      
      {/* Cookie Banner */}
      <div className="fixed bottom-0 left-0 right-0 z-50 animate-in slide-in-from-bottom duration-500">
        <div className="bg-white border-t border-gray-200 shadow-2xl">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              {/* Content */}
              <div className="flex items-start gap-3 flex-1">
                <Cookie className="w-5 h-5 mt-0.5 flex-shrink-0 text-gray-600" />
                <div className="text-sm text-gray-700">
                  <p className="font-medium mb-1">We respect your privacy</p>
                  <p className="text-xs text-gray-600">
                    We use essential cookies to ensure our website works properly and analytics cookies to understand how you interact with it. 
                    We fully comply with <span className="font-semibold">GDPR regulations</span> and respect your privacy choices.
                    {' '}
                    <a 
                      href="/privacy-policy" 
                      className="underline hover:text-gray-900"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Learn more
                    </a>
                  </p>
                </div>
              </div>

              {/* Actions */}
              <div className="flex items-center gap-2 flex-shrink-0">
                <Button
                  size="sm"
                  variant="outline"
                  onClick={handleDecline}
                  className="text-xs h-8"
                >
                  Decline
                </Button>
                <Button
                  size="sm"
                  onClick={handleAccept}
                  className="text-xs h-8 text-white font-medium btn-snow"
                >
                  Accept
                </Button>
                <button
                  onClick={handleAccept}
                  className="ml-2 p-1 hover:bg-gray-100 rounded-full transition-colors"
                  title="Close"
                >
                  <X className="w-4 h-4 text-gray-500" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;
